import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/location_new/chicago/banner_chicago.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Chicago">
                <h1>Mobile App Development Company Chicago</h1>
              </div>
              <p className="main_para">
                Build your dynamic and performant customer-facing applications
                with the leading mobile app development company in Chicago.
                TekRevol helps you plan and launch custom user-adaptive
                products. Our core team of app developers in Chicago uses an
                API-first approach for rapid prototyping, reusability, and
                extensibility. We ensure experience optimization, edge-case
                testing, zero-trust security, and progressive enhancements for
                every app we create.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Start with a Free Consultation
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
